var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.88 15.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 15.9 1.89 15.9 1.89 7.82 2.16 7.82 9.72 15.9 12.49 15.9 4.24 7.25 12.1 0 9.39 0 2.16 6.87 1.89 6.87 1.89 0 0 0 0 15.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.14,
    width: 1.89,
    height: 15.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.98 15.9 27.87 15.9 27.87 2.56 27.91 2.56 33.62 15.9 34.76 15.9 40.46 2.56 40.51 2.56 40.51 15.9 42.4 15.9 42.4 0 39.66 0 34.22 12.46 34.18 12.46 28.79 0 25.98 0 25.98 15.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.34,
    width: 1.89,
    height: 15.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.85,10.24l3.3-7.81h.04l3.14,7.81h-6.49ZM58.47,15.9l1.64-3.91h7.95l1.62,3.91h2.2l-6.76-15.9h-1.77l-7.01,15.9h2.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.271fe47d6025fd0319fa95ca074161fe.svg";
export { ForwardRef as ReactComponent };